import { nikonhero } from "../../assets/images";
import { useNavigate } from "react-router-dom";
import RouteNames from "../../routes/type";
import { useTranslation } from "react-i18next";
import { TbCheck } from "react-icons/tb";
import { Button } from "../../components";

function HomePage() {
  const navigate = useNavigate();
  const handleFindClaim = () => {
    navigate(RouteNames.CREATE_CLAIM);
  };
  const { t } = useTranslation();

  return (
    <div className="">
      <div className="bg-gray-100 text-center p-4  flex items-end justify-center hero-banner">
        <img src={nikonhero} alt="Nikon Welcome" className="mx-auto" />
      </div>
      <div className="sm:mt-12 mt-8">
        <h3 className="font-semibold sm:text-3xl text-[22px] sm:px-10 px-4 text-center">
          {t("Welcome to the Nikon Care Claim Request System")}
        </h3>
        <ul className="min-[400px]:text-lg flex flex-col gap-y-3 mx-auto px-6 w-fit mt-8">
          <li className="flex items-center gap-3">
            <span className="size-6 rounded-full bg-brand-color flex items-center justify-center">
              <TbCheck />
            </span>
            <span>{t("Purchase Details")}</span>
          </li>
          <li className="flex items-center gap-3">
            <span className="size-6 rounded-full bg-brand-color flex items-center justify-center">
              <TbCheck />
            </span>
            <span>{t("Customer Details")}</span>
          </li>
          <li className="flex items-center gap-3">
            <span className="size-6 rounded-full bg-brand-color flex items-center justify-center">
              <TbCheck />
            </span>
            <span>{t("Store Details")}</span>
          </li>
          <li className="flex items-center gap-3">
            <span className="size-6 rounded-full bg-brand-color flex items-center justify-center">
              <TbCheck />
            </span>
            <span>{t("Damaged items")}</span>
          </li>
          <li className="flex items-center gap-3">
            <span className="size-6 rounded-full bg-brand-color flex items-center justify-center">
              <TbCheck />
            </span>
            <span>{t("Submit")}</span>
          </li>
        </ul>
      </div>
      <div className="text-center sm:mt-10 mt-8 mb-6 flex justify-center">
        <Button
          type="button"
          aria-label="button"
          onClick={handleFindClaim}
          // className="p-2 rounded-full text-center bg-brand-color h-[50px] !w-[247px] text-black hover:bg-brand-hover"
          className="!w-[247px] "
        >
          {t("Start")}!
        </Button>
      </div>
    </div>
  );
}

export default HomePage;
